/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScreeningRecordRole
 */
export interface InternalApiScreeningRecordRole {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    recordExternalId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    sinceDay?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    sinceMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    sinceYear?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    toDay?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    toMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    toYear?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecordRole
     */
    occupation?: string;
}

/**
 * Check if a given object implements the InternalApiScreeningRecordRole interface.
 */
export function instanceOfInternalApiScreeningRecordRole(value: object): value is InternalApiScreeningRecordRole {
    if (!('recordExternalId' in value) || value['recordExternalId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function InternalApiScreeningRecordRoleFromJSON(json: any): InternalApiScreeningRecordRole {
    return InternalApiScreeningRecordRoleFromJSONTyped(json, false);
}

export function InternalApiScreeningRecordRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningRecordRole {
    if (json == null) {
        return json;
    }
    return {
        
        'recordExternalId': json['recordExternalId'],
        'type': json['type'],
        'title': json['title'],
        'sinceDay': json['sinceDay'] == null ? undefined : json['sinceDay'],
        'sinceMonth': json['sinceMonth'] == null ? undefined : json['sinceMonth'],
        'sinceYear': json['sinceYear'] == null ? undefined : json['sinceYear'],
        'toDay': json['toDay'] == null ? undefined : json['toDay'],
        'toMonth': json['toMonth'] == null ? undefined : json['toMonth'],
        'toYear': json['toYear'] == null ? undefined : json['toYear'],
        'occupation': json['occupation'] == null ? undefined : json['occupation'],
    };
}

export function InternalApiScreeningRecordRoleToJSON(json: any): InternalApiScreeningRecordRole {
    return InternalApiScreeningRecordRoleToJSONTyped(json, false);
}

export function InternalApiScreeningRecordRoleToJSONTyped(value?: InternalApiScreeningRecordRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recordExternalId': value['recordExternalId'],
        'type': value['type'],
        'title': value['title'],
        'sinceDay': value['sinceDay'],
        'sinceMonth': value['sinceMonth'],
        'sinceYear': value['sinceYear'],
        'toDay': value['toDay'],
        'toMonth': value['toMonth'],
        'toYear': value['toYear'],
        'occupation': value['occupation'],
    };
}

